import { ProductManagement } from "@/components/products/ProductManagement";

export default function ProductsPage() {
  return <ProductManagement />;
}
